import * as api from "../../helpers/api_helper";
import { GET, GET_ALL, GET_BY_USER, POST, PUT, REMOVE } from "./url";
import qs from "qs";

export const getAll = (filter) => api.get(GET_ALL, {
  params: { ...filter },
  paramsSerializer: params => {
    return qs.stringify(params)
  }
});
export const get = (id) => api.get(`${GET}${id}`);
export const GetByUserService = (id) => api.get(`${GET_BY_USER}${id}`);
export const remove = (id) => api.del(`${REMOVE}${id}`);
export const disable = (id) => api.put( `${PUT+'disableAsync?id='}${id}`);
export const post = (user) => api.post(POST,user);
export const update = (user) => api.put(PUT,user);